function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
export default {
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({
    elementsType: function elementsType(s) {
      return s.elements.type;
    },
    elements: function elements(s) {
      return s.elements;
    },
    distance: function distance(s) {
      return s.elements.distance;
    }
  })), mapGetters({
    resultType: 'api/formResultType'
  })), {}, {
    collocationsSide: {
      get: function get() {
        var field = this.elements.type === 'units' ? 'unit' : 'token';

        if (this.elements.left.length === 1 && this.elements.left[0][field].value === '*') {
          return 'left';
        } else if (this.elements.right.length === 1 && this.elements.right[0][field].value === '*') {
          return 'right';
        } else {
          throw 'No collocation element found';
        }
      },
      set: function set(value) {
        if (value !== this.collocationsSide) {
          var _this$$store$commit;

          // Swap collocation and pivot elements
          this.$store.commit('elements/setElements', (_this$$store$commit = {}, _defineProperty(_this$$store$commit, this.pivotSide, this.elements[this.collocationsSide]), _defineProperty(_this$$store$commit, this.collocationsSide, this.elements[this.pivotSide]), _this$$store$commit));
        }
      }
    },
    pivotSide: function pivotSide() {
      return this.collocationsSide === 'left' ? 'right' : 'left';
    },
    maxElements: function maxElements() {
      return this.$ncsConfig.result.collocations.elements.maximum;
    },
    maxDistance: {
      get: function get() {
        return this.distance.number;
      },
      set: function set(value) {
        this.$store.commit('elements/setDistance', {
          type: 'lteq',
          number: parseInt(value)
        });
      }
    },
    positionOptions: function positionOptions() {
      return [{
        value: 'left',
        text: this.$t('elements.collocations.position.left')
      }, {
        value: 'right',
        text: this.$t('elements.collocations.position.right')
      }];
    }
  })
};